// extracted by mini-css-extract-plugin
export default {"cls1":"VeloProgressIndicator-Title_cls1__q7EIx","cls2":"VeloProgressIndicator-Title_cls2__QQgCr VeloProgressIndicator-Title_cls1__q7EIx"};